/**
 * Обчислює різницю між totalTime та timeToSubtract у форматі "Г:ХХ".
 * Якщо результат від'ємний — повертає 0:00.
 *
 * Використовується в компонентах:
 * - AccountTabHome
 * - UserTabHome
 *
 * @param {number} totalTime - Загальний час у годинах (наприклад, 2.5 = 2 години 30 хвилин)
 * @param {number} timeToSubtract - Час, який потрібно відняти (також у годинах)
 * @returns {string} Різниця у форматі "Г:ХХ" (наприклад, "1:15")
 */
export function getCalculateTimeDifference(totalTime, timeToSubtract) {
	// Перетворення годин у хвилини
	const totalMinutes = Math.round(totalTime * 60);
	const subtractMinutes = Math.round(timeToSubtract * 60);

	// Обчислення різниці
	let diffMinutes = totalMinutes - subtractMinutes;

	// Якщо результат < 0 — обнуляємо
	if (diffMinutes < 0) {
		diffMinutes = 0;
	}

	// Перетворення у години і хвилини
	const resultHours = Math.floor(diffMinutes / 60);
	const resultMinutes = diffMinutes % 60;

	// Формування рядка типу "H:MM"
	return `${ resultHours }:${ resultMinutes < 10 ? '0' : '' }${ resultMinutes }`;
}
